import { Plus, ChevronDown, Calendar1 } from 'lucide-react'


export default function GatewaysHeader({ openModal, setOpenModal }: { openModal: boolean; setOpenModal: (openModal: boolean) => void }) {
    return (
        <div className="w-full flex flex-col items-start justify-start">
            <div className="flex items-center gap-x-6">
                <nav className="flex text-white text-xs">
                    <ul className="flex gap-x-6">
                        <li>All</li>
                        <li>Active</li>
                        <li>Inactive</li>
                    </ul>
                </nav>

                <button className="w-fit flex items-center justify-center gap-x-1 bg-transparent border border-gray-400 rounded-md px-3 py-2 text-white text-xs hover:scale-105 transition-all cursor-pointer"
                onClick={() => setOpenModal(true)}>
                    <Plus />
                    Create Gateway
                </button>
            </div>

            <div className="flex items-center gap-x-4 my-3">
                    <div className="relative">
                        <select className="w-40 h-8 px-3 py-1 rounded-md border border-gray-400 bg-white text-xs text-gray-700">
                            <option value="">Services</option>
                            <option value="">Kanema Online</option>
                            <option value="">Mingoli</option>
                            <option value="">Katswiri</option>
                            <option value="">Nkhani</option>
                        </select>
                    </div>

                    <div className="relative">
                        <select className="w-40 h-8 px-3 py-1 rounded-md border border-gray-400 bg-white text-xs text-gray-700">
                            <option value="">Status</option>
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                            <option value="pending">Pending</option>
                        </select>
                    </div>

                    <div className="relative">
                        <select className="w-40 h-8 px-3 py-1 rounded-md border border-gray-400 bg-white text-xs text-gray-700">
                            <option value="">Activity</option>
                            <option value="">Most Used</option>
                            <option value="">Least Used</option>
                        </select>
                    </div>
                </div>

        </div>
    )
}